import { createContext, useContext } from 'react';

import { RenderModeEnum } from '../../../../utils/widgets';

type WidgetContextType = {
	renderMode: RenderModeEnum;
};

export const WidgetExternalApplicationsContext = createContext<WidgetContextType | undefined>(undefined);

export const useWidgetExternalApplicationsContext = () => {
	const context = useContext(WidgetExternalApplicationsContext);

	if (context === undefined) {
		throw new Error('WidgetExternalApplicationsContext should be used within WidgetExternalApplications');
	}

	return context;
};
